import React from "react";
import { Table } from "antd";

const SbTable = ({
  columns,
  dataSource,
  loading,
  pagination,
  rowKey,
  expandable,
  rowClassName,
  onRow,
  ...rest
}) => {
  const finalPagination =
    pagination === false
      ? false
      : {
          defaultPageSize: 20,
          pageSizeOptions: ["10", "20", "30"],
          showSizeChanger: true,
          ...pagination,
        };

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={finalPagination}
      rowKey={rowKey}
      expandable={expandable}
      rowClassName={rowClassName}
      onRow={onRow}
      {...rest}
    />
  );
};

export default SbTable;